var map = {
	"./Logo.png": 5417,
	"./add-small-blue.png": 2885,
	"./add-small.png": 3197,
	"./akt.png": 1441,
	"./akt1.png": 2343,
	"./ava.png": 5229,
	"./chat.png": 2704,
	"./checkmark.png": 8402,
	"./chevron-right.png": 2536,
	"./dots-vertical.png": 4245,
	"./down.png": 5846,
	"./editprice.png": 2287,
	"./groupview.png": 8083,
	"./home.png": 3685,
	"./left.png": 8659,
	"./left1.png": 7932,
	"./listview.png": 9821,
	"./menu.png": 3643,
	"./nav/application-statuses.png": 458,
	"./nav/application-types.png": 984,
	"./nav/areas.png": 4398,
	"./nav/audit-log.png": 4738,
	"./nav/authorities-issuing.png": 7240,
	"./nav/basis-expenditure.png": 7716,
	"./nav/branches.png": 6455,
	"./nav/brands.png": 9137,
	"./nav/cars.png": 3162,
	"./nav/customers.png": 532,
	"./nav/double-caret-left.png": 8299,
	"./nav/employees.png": 6897,
	"./nav/gold.png": 4130,
	"./nav/goods.png": 5399,
	"./nav/group.png": 7350,
	"./nav/guarantee-period.png": 5312,
	"./nav/home.png": 1825,
	"./nav/logout.png": 6422,
	"./nav/m_audit-log.png": 5137,
	"./nav/m_customers.png": 6746,
	"./nav/m_employees.png": 5323,
	"./nav/m_gold.png": 4082,
	"./nav/m_goods.png": 1445,
	"./nav/m_group.png": 7722,
	"./nav/m_qr.png": 783,
	"./nav/m_reference.png": 919,
	"./nav/m_regdoc.png": 3017,
	"./nav/m_sales-plans.png": 8564,
	"./nav/m_service.png": 2443,
	"./nav/m_stock.png": 9966,
	"./nav/manbook.png": 7725,
	"./nav/manufacturer-country.png": 8536,
	"./nav/payment-methods.png": 124,
	"./nav/payment-state.png": 9698,
	"./nav/qr.png": 2669,
	"./nav/reference.png": 6959,
	"./nav/regdoc.png": 9811,
	"./nav/return-type.png": 2958,
	"./nav/right.png": 1569,
	"./nav/roles.png": 1042,
	"./nav/sales-plans.png": 3598,
	"./nav/service-statuses.png": 4080,
	"./nav/service.png": 6015,
	"./nav/stock.png": 7088,
	"./nav/types-discounts.png": 1689,
	"./nav/types-identity-documents.png": 6061,
	"./nav/types-services.png": 3186,
	"./notice.png": 3921,
	"./pencil-alt.png": 7962,
	"./profile.png": 928,
	"./qr.png": 7118,
	"./right.png": 4953,
	"./right11.png": 3335,
	"./search.png": 5960,
	"./trash.png": 3696,
	"./user.png": 856,
	"./user_profile.png": 2431,
	"./x.png": 1139,
	"./xx.png": 9863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;